import axios from 'axios'
import {
  call,
  cancel,
  cancelled,
  fork,
  put,
  select,
  take,
} from 'redux-saga/effects'

import { setCollection } from '../../features/collection/collectionSlice'
import { RequestCollection } from '../requests/requestCollection'

export function* collectionAPI() {
  const data = yield select()
  const user = data.user.userAccount
  return new Promise(async (resolve, reject) => {
    try {
      const collection = await RequestCollection()
      resolve(collection)
      console.log('API Collection:', collection)
    } catch (error) {
      reject(error)
    }
  })
}

function getFullCollection() {
  return new Promise(async (resolve, reject) => {
    try {
      const collection = await axios.get(
        // Mainnet
        // 'https://wax.api.atomicassets.io/atomicassets/v1/templates?collection_name=galaktikanft&limit=1000&order=desc&sort=name'
        //  Testnet
        'https://test.wax.api.atomicassets.io/atomicassets/v1/templates?collection_name=galaktiktest&limit=1000&order=desc&sort=name',
      )
      resolve(collection)
      console.log('All Collection:', collection)
      return collection
    } catch (error) {
      reject(error)
    }
  })
}

export function* resolveCollection() {
  try {
    const collectionData = yield call(collectionAPI)
    const fullCollectionData = yield call(getFullCollection)
    const { data } = yield collectionData
    const { data: fullColData } = yield fullCollectionData
    yield put(
      setCollection({
        type: 'FETCHING_SUCCESS',
        collections: data,
        fullNFTCollection: fullColData.data,
      }),
    )
  } catch (error) {
    const errorMsg = error.toString()
    yield put(setCollection({ type: 'FETCHING_ERROR', error: errorMsg }))
  } finally {
    if (yield cancelled()) {
      yield put(setCollection({ type: 'FETCHING_CANCELLED' }))
    }
  }
}

export function* collectionFlow() {
  while (true) {
    yield put(setCollection({ type: 'GET_COLLECTION' }))
    const task = yield fork(resolveCollection)
    const action = yield take(['FETCHING_ERROR'])
    if (action.type === 'STOP_FETCHING') {
      yield cancel(task)
    }
  }
}
